import type { VentaRow } from '@/lib/ventas/types';

interface Props {
  ventas: VentaRow[];
  exportingId: string | null;
  onVerDetalle: (venta: VentaRow) => void;
  onComprobante: (venta: VentaRow) => void;
}

function formatBs(val: number): string {
  return `Bs. ${Number(val || 0).toFixed(2)}`;
}

export default function VentasTabla({ ventas, exportingId, onVerDetalle, onComprobante }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[820px]">
        <thead>
          <tr className="border-b border-background-200 bg-background-50">
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Fecha</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Cliente</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">NIT / CI</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Método</th>
            <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Atendió</th>
            <th className="text-right px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Total</th>
            <th className="text-right px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {ventas.map((v) => (
            <tr key={v.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
              <td className="px-4 py-3">
                <p className="text-sm font-medium text-foreground-700">
                  {new Date(v.fecha).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}
                </p>
                <p className="text-xs text-foreground-400">
                  {new Date(v.fecha).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                </p>
              </td>
              <td className="px-4 py-3">
                <span className="text-sm text-foreground-500">{v.nombre_nit || 'Consumidor Final'}</span>
              </td>
              <td className="px-4 py-3">
                <span className="text-sm text-foreground-500">{v.numero_nit || '—'}</span>
              </td>
              <td className="px-4 py-3">
                <span
                  className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${
                    v.metodo_pago === 'Efectivo' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                  }`}
                >
                  <i className={v.metodo_pago === 'Efectivo' ? 'ri-money-dollar-circle-line' : 'ri-qr-code-line text-xs'}></i>
                  {v.metodo_pago}
                </span>
              </td>
              <td className="px-4 py-3">
                <span className="text-sm text-foreground-500">{v.usuario_nombre}</span>
              </td>
              <td className="px-4 py-3 text-right">
                <span className="text-sm font-semibold text-foreground-800">{formatBs(Number(v.total))}</span>
              </td>
              <td className="px-4 py-3">
                <div className="flex items-center justify-end gap-1">
                  <button
                    onClick={() => onVerDetalle(v)}
                    className="p-2 rounded-lg text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
                    title="Ver detalle"
                  >
                    <i className="ri-eye-line text-lg"></i>
                  </button>
                  <button
                    onClick={() => onComprobante(v)}
                    disabled={exportingId === v.id}
                    className="p-2 rounded-lg text-foreground-400 hover:text-accent-600 hover:bg-accent-50 transition-colors cursor-pointer disabled:opacity-50"
                    title="Descargar comprobante"
                  >
                    {exportingId === v.id ? (
                      <i className="ri-loader-4-line animate-spin text-lg"></i>
                    ) : (
                      <i className="ri-file-pdf-line text-lg"></i>
                    )}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}